import React from "react";
import { Box, IconButton, Link, Typography, styled } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";

const ContactWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(2),
  padding: theme.spacing(4, 2),
  backgroundColor: theme.palette.background.default,
}));

const ContactActions = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  alignItems: "center",
}));

const ContactSection: React.FC = () => {
  return (
    <ContactWrapper>
      <Typography variant="h6" fontWeight={700} textAlign="center">
        ¿No encuentras lo que buscas?
      </Typography>
      <Typography variant="body2" color="text.primary" textAlign="center">
        Contáctanos y te ayudamos a encontrar lo que necesitas.
      </Typography>
      <ContactActions>
        <IconButton
          component={Link}
          href="https://wa.me/573128014133"
          target="_blank"
          rel="noopener"
          sx={{ color: "brand.whatsapp" }}
        >
          <WhatsAppIcon fontSize="large" />
        </IconButton>
        <IconButton
          component={Link}
          href="mailto:entornobiai@gmail.com"
          sx={{ color: "text.primary" }}
        >
          <EmailIcon fontSize="large" />
        </IconButton>
      </ContactActions>
    </ContactWrapper>
  );
};

export default ContactSection;
